
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_people/components/settings_editor/templates/integrations"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<section class='modal_content_section'>\n  <header class='modal_content_section_header'>\n    <h1 class='section_title'>\n      Connected Accounts\n    </h1>\n    <span class='modal_content_section_description'>\n      Connect the tools you use so Opal can work alongside them.\n    </span>\n  </header>\n  <div class='integration_connections'></div>\n</section>\n";
},"useData":true});
    }).call(this);
  